export default __webpack_public_path__ + "static/media/acm_close_white_icon.d3a80d4f.svg";